import { css } from '@linaria/core';
import { breakpointConfig, theming } from 'styles/utils';
export const container = "omponents__NoAppState__NoStarredResource_styles_ts-container-ch1du1p";
export const textContainer = "omponents__NoAppState__NoStarredResource_styles_ts-textContainer-tiylxll";
export const titleStyle = "omponents__NoAppState__NoStarredResource_styles_ts-titleStyle-t1jq4deb";
export const subtitleStyle = "omponents__NoAppState__NoStarredResource_styles_ts-subtitleStyle-s13u5osg";

require("./NoStarredResource.styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./NoStarredResource.styles.ts");